import type { ReactNode } from 'react';
import styles from './style.module.css';

export function SectionHead({ children, tag }: { children: ReactNode; tag?: string }) {
  return (
    <div className={styles.head}>
      <h2 className={`${styles.title} hand`}>{children}</h2>
      <div className={styles.underline} />
      {tag && <span className={styles.tag}>{tag}</span>}
    </div>
  );
}
